module.exports = __webpack_public_path__ + "static/media/ambassadors-who-are.c64f88b1.jpg";